<template>
  <div id="contenedor-detalles-contrato">
    <template
      v-if="$apollo.loading">
      <v-progress-linear
      indeterminate
      absolute
      top
      color="primary"
      height="10">
      </v-progress-linear>
    </template>
    <template v-else>
      <v-card-title class="primary--text">
        <v-row justify="end">
          <h1 style="font-size:30px">
            {{ getContrato.numero }}
          </h1>
        </v-row>
          <v-spacer></v-spacer>
          <v-btn
              icon
              @click="cerrarPanelDetalles">
              <v-icon class="primary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <!-- <v-row justify="center" align="center">
          <h1 class="primary--text" style="font-size:30px">
          {{ getContrato.numero }}
          </h1>
        </v-row> -->
        <v-card-text>
          <v-row>
            <h3 class="secondary--text">Objeto:</h3>
          </v-row>
            <cortar-textos
            :texto="getContrato.meta">
          </cortar-textos>
          <v-row class="pt-2">
            <h3 class="secondary--text">Contratista:</h3>
          </v-row>
          <v-row>
            {{ getContrato.contratista.nombreRazonSocial }}
          </v-row>
          <v-row>
            <v-col class="px-0">
              <v-row>
                <h3 class="secondary--text">Avance Físico:</h3>
              </v-row>
              <v-row>
                {{ getUltimoReporte ? getUltimoReporte.avanceFisico : '0' }}%
              </v-row>
            </v-col>
            <v-col class="px-0">
              <v-row>
                <h3 class="secondary--text">Fecha de Reporte:</h3>
              </v-row>
              <v-row>
                {{ getUltimoReporte ? new Date(`${getUltimoReporte.fecha} 00:00:0`)
                  .toLocaleDateString() : 'Sin Reportes' }}
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <div id="contenedor-album-fotografico">
          <v-row justify="start">
            <template
              v-for="(imagen, index) in getImagenesUltimoReporte">
              <template>
                <v-col
                  cols="auto"
                  class="pa-1"
                  :key="`img-${index}`">
                  <v-img
                    :src="getUrlImagen(imagen)"
                    height="145"
                    width="145"
                    contain
                    class="blue-grey darken-4"
                    style="cursor: pointer;"
                    @click="verImagen(index)">
                  </v-img>
                </v-col>
              </template>
            </template>
          </v-row>
        </div>
      <div>
        <v-card
          class="mt-4 py-4 primary"
          flat
          dark>
          <span
            class="text-h5 text-center d-block">
            Inversión: {{ getTotalContrato | currency }}
          </span>
        </v-card>
      </div>
    </template>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CortarTextos from '@/components/CortarTextos.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'DetallesContrato',
  components: {
    CortarTextos,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.idContrato,
        };
      },
    },
  },
  methods: {
    cerrarPanelDetalles() {
      eventBus.$emit('cerrarPanelDetalles');
    },
    getUrlImagen(imagen) {
      const url = `${this.$urlFileServer}/${imagen}`;
      return url;
    },
    verImagen(index) {
      const imagenes = {
        indexImagenVer: index,
        imagenesParaVer: this.getImagenesUltimoReporte,
      };
      eventBus.$emit('verImagen', imagenes);
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getUltimoReporte() {
      if (!this.contrato) return {};
      const ultimoReporte = this.getContrato.reportesFisicos
        .find(({ esUltimo }) => esUltimo === true);
      return ultimoReporte || null;
    },
    getImagenesUltimoReporte() {
      if (!this.getUltimoReporte) return [];
      const imagenes = [];
      this.getUltimoReporte.partidas.forEach((partida) => {
        if (partida.imagenes) {
          partida.imagenes.forEach((imagen) => {
            imagenes.push(imagen);
          });
        }
      });
      return imagenes;
    },
    getTotalContrato() {
      if (!this.contrato) return 0;
      if (this.contrato.modificado.total <= 0) return this.contrato.total;
      return this.contrato.total + this.contrato.modificado.total;
    },

  },
};
</script>

<style lang="scss" scoped>

</style>
